import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Resource } from "../../../core/coreResource";
import { PaymentDetails, PaymentPageDetails } from "../models/paymentdetails";
import { PaymentRequest } from "../models/makepaymentReq";
import { Observable, of } from "rxjs";
import { DataService } from "../data.service";
import { environment } from "../../../../environments/environment";
import {
  AccountTransfer,
  CheckoutSettings,
  ConfirmAccountTransfer,
  Invoice,
  OpayInitiateBankTransactionResponse,
  USSDBank,
} from "src/app/core/models/model";
import { catchError, map, shareReplay } from "rxjs/operators";
import {
  AccountData,
  BankPaymentRequest,
  StatusResponse,
  ValidateAccount,
} from "../models/bankPaymentRes";

@Injectable({
  providedIn: "root",
})
export class PaymentService {
  baseUrl: string = environment.url;
  ngurl = this.resource.baseurl;
  // baseUrl = this.resource.baseurl;
  hostUrl = this.resource.hostUrl;
  ghUrl = this.resource.ghbaseurl;
  mgsurl = this.resource.mpgsBaseUrl;
  cpsUrl = this.resource.cpsUrl;
  supportUrl = environment.supportUrl;

  constructor(
    private http: HttpClient,
    private resource: Resource,
    private dserv: DataService,
  ) {
    // this.dserv.baseUrl$.subscribe((res) => (this.baseUrl = res));
  }

  getPaymentDetails(reference) {
    return this.http.get<PaymentDetails>(
      `${this.baseUrl}${this.resource.paymentDetails}/${reference}`,
    );
  }

  getPaymentPageDetails(reference) {
    return this.http.get<PaymentPageDetails>(
      `${this.baseUrl}${this.resource.paymentPageDetails}${reference}`,
    );
  }

  //2. next endpoint to be called. create the payment after no.1 above
  createPayment(req) {
    return this.http.post(
      `${this.baseUrl}${this.resource.createPayment}`,
      JSON.stringify(req),
    );
  }

  makePayment(req: PaymentRequest) {
    return this.http.post(
      `${this.baseUrl}${this.resource.makePayment}`,
      JSON.stringify(req),
    );
  }

  checkPaymentStatus(clientId, ref) {
    return this.http.get(
      `${this.baseUrl}${this.resource.paymentRequery}${clientId}/${ref}`,
    );
  }

  checkPaymentStatusForGhanaInnerFrame(clientId, ref) {
    return this.http.get(
      `${this.ghUrl}${this.resource.paymentRequery}${clientId}/${ref}`,
    );
  }

  getBanks() {
    // return this.http.get("../../assets/banks.json");
    return of([
      {
        "name": "ACCESS BANK",
        "Code": "044"
      },
      {
        "name": "CITI BANK",
        "Code": "023"
      },
      {
        "name": "DIAMOND BANK",
        "Code": "063"
      },
      {
        "name": "ECOBANK NIGERIA",
        "Code": "050"
      },

      {
        "name": "FIDELITY BANK ",
        "Code": "070"
      },
      {
        "name": "FIRST BANK OF NIGERIA",
        "Code": "011"
      },
      {
        "name": "FIRST CITY MONUMENT BANK",
        "Code": "214"
      },
      {
        "name": "GUARANTY TRUST BANK",
        "Code": "058"
      },
      {
        "name": "HERITAGE BANK",
        "Code": "030"
      },

      {
        "name": "JAIZ BANK",
        "Code": "301"
      },
      {
        "name": "KEYSTONE BANK",
        "Code": "082"
      },
      {
        "name": "PROVIDUS BANK",
        "Code": "101"
      },
      {
        "name": "STANBIC IBTC BANK",
        "Code": "221"
      },

      {
        "name": "SKYE BANK",
        "Code": "076"
      },
      {
        "name": "SUNTRUST BANK",
        "Code": "100"
      },
      {
        "name": "STANDARD CHARTERED BANK",
        "Code": "068"
      },
      {
        "name": "STERLING BANK",
        "Code": "232"
      },
      {
        "name": "UNION BANK",
        "Code": "032"
      },
      {
        "name": "UNITED BANK FOR AFRICA",
        "Code": "033"
      },
      {
        "name": "UNITY BANK",
        "Code": "215"
      },
      {
        "name": "WEMA BANK",
        "Code": "035"
      },

      {
        "name": "ZENITH BANK",
        "Code": "057"
      }

    ])
  }

  getUssdBanks(): Observable<USSDBank[]> {
    // return this.http.get<USSDBank[]>("../../assets/ussdbanks.json");
    return of([
      {
        "name": "ACCESS BANK",
        "Code": "044"
      },
      {
        "name": "ECOBANK NIGERIA",
        "Code": "050"
      },

      {
        "name": "FIDELITY BANK ",
        "Code": "070"
      },
      {
        "name": "FIRST BANK OF NIGERIA",
        "Code": "011"
      },
      {
        "name": "FIRST CITY MONUMENT BANK",
        "Code": "214"
      },
      {
        "name": "GUARANTY TRUST BANK",
        "Code": "058"
      },

      {
        "name": "KEYSTONE BANK",
        "Code": "082"
      },

      {
        "name": "STANBIC IBTC BANK",
        "Code": "221"
      },
      {
        "name": "STERLING BANK",
        "Code": "232"
      },
      {
        "name": "UNITED BANK FOR AFRICA",
        "Code": "033"
      },
      {
        "name": "UNITY BANK",
        "Code": "215"
      },
      {
        "name": "VFD",
        "Code": "322"
      },
      {
        "name": "WEMA BANK",
        "Code": "035"
      },

      {
        "name": "ZENITH BANK",
        "Code": "057"
      },
      {
        "name": "ACCESS DIAMOND BANK",
        "Code": "063"
      },
      {
        "name": "Union Bank",
        "Code": "032"
      },
      {
        "name": " RUBIES (HIGHSTREET) MFB",
        "Code": "587"
      },
      {
        "name": "GLOBUS BANK",
        "Code": "103"
      },
      {
        "name": "PREMIUM TRUST BANK",
        "Code": "105"
      },
      {
        "name": "LOTUS BANK",
        "Code": "303"
      }
    ]
    )
  }

  //Validate to ensure that a malicious reference is not sent to the server.
  validateBaseUrlPath(reference) {
    // let pathName = window.location.pathname;
    let pathName = reference;
    let paymentReference = pathName.replace(/\//, "");

    if (this.hostUrl === window.location.hostname) {
      let regex = /^[A-Za-z0-9]+$/;
      if (regex.test("regex") === true) {
        return paymentReference;
      } else {
        alert("Hey!!. Invalid request.. Do not try anything funny... ");
      }
    } else {
      alert("Hey!!. Invalid request.. Do not try anything funny... ");
    }
  }

  // MGS related calls <Please clean this up>
  //   merchantId: string = "323GA1120001";
  // apiPassword: string = "789a1c12de4cb8fde7021a975ac60541";

  createSession(): Observable<any> {
    return this.http.post<any>(
      `https://cps.globalaccelerex.com.gh${this.resource.creatMPGSeSession}`,
      {
        session: {
          authenticationLimit: 25,
        },
      },
      // this.options
    );
  }

  updateSession(requestBody): Observable<any> {
    return this.http.put<any>(
      `https://cps.globalaccelerex.com.gh${this.resource.updateMPGSSession}`,
      requestBody,
    );
  }

  makePaymentTransaction(requestDetails): Observable<any> {
    return this.http.put<any>(
      `https://cps.globalaccelerex.com.gh${this.resource.makeMPGSPayment}`,
      requestDetails,
      // this.options
    );
  }

  //this is required for the initialisation of the payment link
  setBaseUrl() {
    if (location.href.includes("/gh/")) {
      this.dserv.setBaseUrlState(environment.ghurl);
    } else {
      this.dserv.setBaseUrlState(environment.url);
    }
  }

  //  this is for the pgp encryption
  processCard(req) {
    return this.http.post<any>(
      `${this.cpsUrl}/api/cps/v1/chargeCard`,
      JSON.stringify(req),
    );
  }

  authorizeCard(otp: any) {
    return this.http.post<any>(
      `${this.cpsUrl}/api/cps/v1/authorizeTransaction`,
      JSON.stringify(otp),
    );
  }

  getCheckoutSettings(clientId: string): Observable<CheckoutSettings> {
    return this.http.get<CheckoutSettings>(
      `${this.baseUrl}/api/pgs/clients/v1/checkoutSettings/${clientId}`,
    );
  }

  createRating(payload) {
    return this.http.post(
      `${this.supportUrl}${this.resource.createRating}`,
      payload,
    );
  }

  payWithTransfer(payload): Observable<AccountTransfer> {
    return this.http.post<AccountTransfer>(
      `${this.cpsUrl}${this.resource.payWithTransfer}`,
      payload,
    );
  }

  initiateBankTransaction(payload) {
    return this.http.post<OpayInitiateBankTransactionResponse>(
      `${this.cpsUrl}${this.resource.initiateBankTransaction}`,
      payload,
    );
  }

  //  makeOPayment(payload: any) {
  //   return this.http.post<any>(
  //     `${this.cpsUrl}/api/cps/v1/makePayment`,
  //     JSON.stringify(otp)
  //   );
  //  }

  confirmTransfer(
    payload,
    bankTransfer?: boolean,
    is3ds?: boolean,
  ): Observable<ConfirmAccountTransfer> {
    const headers = new HttpHeaders()
      .set("X-Bypass-Interceptor", "true")
      .set("Bank-Transfer", bankTransfer ? "true" : "false")
      .set("3DS", is3ds ? "true" : "false");
    return this.http.post<ConfirmAccountTransfer>(
      `${this.cpsUrl}${this.resource.confirmTransfer}`,
      payload,
      { headers },
    );
  }

  getRecurringPayment(reference: string, clientId: string): Observable<any> {
    const headers = new HttpHeaders({
      x_client_id: clientId,
    });
    return this.http.get(
      `${this.baseUrl}/api/pgs/subscription/v1/plans/details/${reference}`,
      { headers },
    );
  }

  getInstalmentPlan(reference: string, clientId: string): Observable<any> {
    const headers = new HttpHeaders({
      x_client_id: clientId,
    });
    return this.http.get(
      `${this.baseUrl}/api/pgs/instalment/v1/plan/${reference}`,
      { headers },
    );
  }

  createRecurringPayment(payload) {
    const headers = new HttpHeaders({
      x_client_id: payload.clientId,
    });
    // this.baseUrl = "https://1687-105-113-72-230.ngrok-free.app";
    return this.http.post(
      `${this.baseUrl}/api/pgs/payment/v1/recurring/payment`,
      payload,
      { headers },
    );
  }

  verifyBankAccount(
    accountNumber: string,
    sortCode: string,
    clientId: string,
  ): Observable<AccountData> {
    let params = new HttpParams();

    params = params.append("accountNumber", accountNumber);
    params = params.append("accountCode", sortCode);
    params = params.append("clientId", clientId);
    params = params.append("provider", "habari");

    const headers = new HttpHeaders({
      x_client_id: clientId,
    });

    return this.http
      .get<StatusResponse<AccountData>>(
        `${this.baseUrl}/api/pgs/verification/v1/getAccountLookup`,
        {
          params,
          headers,
        },
      )
      .pipe(
        map((res: StatusResponse<AccountData>) => res.data),
        shareReplay(),
      );
  }

  makeRecurringBankPayment(payload: BankPaymentRequest): Observable<any> {
    const headers = new HttpHeaders({
      x_client_id: payload.clientId,
    });

    // this.baseUrl = "https://1687-105-113-72-230.ngrok-free.app";

    return this.http.post(
      `${this.baseUrl}/api/pgs/subscription/v1/subscriptions/account`,
      payload,
      { headers },
    );
  }

  makeInstalmentBankPayment(payload) {
    const headers = new HttpHeaders({
      x_client_id: payload.clientId,
    });

    return this.http.post(
      `${this.baseUrl}/api/pgs/instalment/v1/account/payment`,
      payload,
      { headers },
    );
  }

  makeRecurringCardPayment(payload) {
    const headers = new HttpHeaders({
      x_client_id: payload.clientId,
    });

    // this.baseUrl = "https://1687-105-113-72-230.ngrok-free.app";

    return this.http.post(
      `${this.baseUrl}/api/pgs/subscription/v1/subscriptions/card`,
      payload,
      { headers },
    );
  }

  makeInstalmentCardPayment(payload) {
    const headers = new HttpHeaders({
      x_client_id: payload.clientId,
    });

    // this.baseUrl = "https://1687-105-113-72-230.ngrok-free.app";

    return this.http.post(
      `${this.baseUrl}/api/pgs/instalment/v1/card/payment`,
      payload,
      { headers },
    );
  }

  authorizeRecurringPayment(req, clientId, ref): Observable<any> {
    const headers = new HttpHeaders({
      x_client_id: clientId,
    });

    // this.baseUrl = "https://1687-105-113-72-230.ngrok-free.app";
    return this.http.post(
      `${this.baseUrl}/api/pgs/subscription/v1/subscriptions/${ref}/authorize`,
      req,
      { headers },
    );
  }

  encryptOTP(payload, clientId): Observable<any> {
    const headers = new HttpHeaders({
      x_client_id: clientId,
    });
    return this.http.post(
      `${this.baseUrl}/api/cps/v1/qaencrypt/auth/otp`,
      payload,
      { headers },
    );
  }

  getInvoice(code: string): Observable<Invoice> {
    return this.http
      .get<Invoice>(
        `${this.baseUrl}/api/pgs/admin/v1/getInvoiceDetails/${code}`,
      )
      .pipe(
        catchError(() => of({} as Invoice)),
        shareReplay(),
      );
  }

  logTransactionActivity(payload) {
    const headers = new HttpHeaders().set("X-Bypass-Interceptor", "true");
    return this.http.post(`${this.baseUrl}/logTransactionActivity`, payload, {
      headers,
    });
  }

  resendOtp(req): Observable<any> {
    return this.http.post<any>(
      `${this.cpsUrl}/api/cps/v1/resendOTP`,
      JSON.stringify(req),
    );
  }

  validateAccountPayment(payload: ValidateAccount): Observable<any> {
    const headers = new HttpHeaders({
      x_client_id: payload.clientId,
    });
    return this.http.post(
      `${this.baseUrl}/api/pgs/subscription/v1/subscriptions/account/validate`,
      payload,
      { headers },
    );
  }

  validateInstalmentAccount(payload: ValidateAccount): Observable<any> {
    const headers = new HttpHeaders({
      x_client_id: payload.clientId,
    });
    return this.http.post(
      `${this.baseUrl}/api/pgs/instalment/v1/account/validate`,
      payload,
      { headers },
    );
  }

  processSubscription(payload): Observable<any> {
    const headers = new HttpHeaders({
      x_client_id: payload.clientId,
    });
    return this.http.post(
      `${this.baseUrl}/api/pgs/subscription/v1/subscriptions/account/payment`,
      payload,
      { headers },
    );
  }

  processInstalmentAccountPayment(payload): Observable<any> {
    const headers = new HttpHeaders({
      x_client_id: payload.clientId,
    });
    return this.http.post(
      `${this.baseUrl}/api/pgs/instalment/v1/process/account/payment`,
      payload,
      { headers },
    );
  }

  getBanksList(): Observable<any> {
    return this.http.get(`${this.cpsUrl}${this.resource.getBanksList}`).pipe(
      catchError(() => of({} as Invoice)),
      shareReplay(),
    );
  }
  validateCollection(reference: string): Observable<any> {
    return this.http.post(`${this.cpsUrl}${this.resource.validateCollection}`, {
      reference,
    });
  }

  collectionNotification(reference: string): Observable<any> {
    return this.http.post(
      `${this.cpsUrl}${this.resource.collectionNotification}`,
      { reference },
    );
  }
  initiateCard(payload: any): Observable<any> {
    return this.http.post(
      `${this.cpsUrl}${this.resource.initiateCard}`,
      payload,
    );
  }
}
